export { DesignSystemGlobalsProvider } from "./DesignSystemGlobals";
export type { IDesignSystemGlobals } from "./DesignSystemGlobals";
